import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'validate.js';

import { isNumeric } from 'dpl/shared/form/utils';
import TransportationSection from 'dpl/common/components/TransportationSection';

export default function LocationAndPickup() {
  const { breederAddress, searchUserCoordinates, buyerDistanceInMiles } =
    useSelector(({ server }) => server);

  const { breederCoordinates, buyerCoordinates } = useMemo(() => {
    if (!breederAddress?.latitude || !breederAddress?.longitude) {
      return { breederCoordinates: null, buyerCoordinates: null };
    }

    return {
      breederCoordinates: {
        lat: breederAddress.latitude,
        lng: breederAddress.longitude
      },
      buyerCoordinates:
        !isEmpty(searchUserCoordinates) &&
        isNumeric(buyerDistanceInMiles) &&
        buyerDistanceInMiles <= 200
          ? {
              lat: searchUserCoordinates[0],
              lng: searchUserCoordinates[1]
            }
          : null
    };
  }, []);

  const coordinates = useMemo(() => {
    return [breederCoordinates, buyerCoordinates].filter(Boolean);
  }, [breederCoordinates, buyerCoordinates]);

  return (
    <div className="LocationAndPickup">
      <TransportationSection
        coordinates={coordinates}
        sectionTitle="Location & pick-up"
      />
    </div>
  );
}
